import BaseModel from "./base.model";

export default class AddressModel extends BaseModel {

  building = "";
  street_number = ""
  street = "";
  combined_number_street = ""
  area = "";
  city = "";
  province = "";
  province_code = "";
  code = "";
  country = "";
  country_code = "";
  instructions = "";
  is_valid = this.isValidAddress();

  constructor (data) {
    super();
    if (this.isEmpty(data)) return this;
    this.building = data.building;
    this.street_number = data.street_number;
    this.street = data.street;
    this.combined_number_street = data.combined_number_street;
    this.area = data.area;
    this.city = data.city;
    this.province = data.province;
    this.province_code = data.province_code;
    this.code = data.code;
    this.country = data.country;
    this.country_code = data.country_code;
    this.instructions = data.instructions
    this.is_valid = this.isValidAddress();
  }

  isValidAddress() {
    return !this.isEmpty(this.combined_number_street) &&
      !this.isEmpty(this.area) &&
      !this.isEmpty(this.city) &&
      !this.isEmpty(this.province)
  }

  validateAddress() {
    this.is_valid = this.isValidAddress();
  }
}
